export default __webpack_public_path__ + "static/media/funds.ebd7937c.svg";